import axios from '../../utils/api';

export default {
    state: {
        currencies: {},
        currencies_flip: {},
        currencies_flip_full: {},
        currencies_all: {},
        currencies_icons: {},
        currencies_settings: [],
        currencies_settings_by_currency: [],
        commissions_refill: {},
        commissions_withdraw: {},
        networkAliases: {
            ETH: 'ERC-20',
            TRX: 'TRC-20',
            BSC: 'BEP-20',
            Main: 'Mainnet'
        },
        // Prohibited territories Crimea, Donetsk, Luhansk, Zaporizhzhia, Kherson, Sevastopol are cities/regions, not ISO countries - not in list. Blocked countries below are commented out.
        AllCountriesList: {
            "AF": "Afghanistan",
            "AX": "Åland Islands",
            "AL": "Albania",
            "DZ": "Algeria",
            "AS": "American Samoa",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguilla",
            "AQ": "Antarctica",
            "AG": "Antigua and Barbuda",
            "AR": "Argentina",
            "AM": "Armenia",
            "AW": "Aruba",
            "AU": "Australia",
            "AT": "Austria",
            "AZ": "Azerbaijan",
            "BS": "Bahamas",
            "BH": "Bahrain",
            "BD": "Bangladesh",
            "BB": "Barbados",
            // "BY": "Belarus", // blocked
            "BE": "Belgium",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermuda",
            "BT": "Bhutan",
            // "BO": "Bolivia, Plurinational State of", // blocked
            "BQ": "Bonaire, Sint Eustatius and Saba",
            "BA": "Bosnia and Herzegovina",
            "BW": "Botswana",
            "BV": "Bouvet Island",
            "BR": "Brazil",
            "IO": "British Indian Ocean Territory",
            "BN": "Brunei Darussalam",
            "BG": "Bulgaria",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Cambodia",
            // "CM": "Cameroon", // blocked
            // "CA": "Canada", // blocked
            "CV": "Cape Verde",
            "KY": "Cayman Islands",
            "CF": "Central African Republic",
            "TD": "Chad",
            "CL": "Chile",
            "CN": "China",
            "CX": "Christmas Island",
            "CC": "Cocos (Keeling) Islands",
            "CO": "Colombia",
            "KM": "Comoros",
            "CG": "Congo",
            // "CD": "Congo, the Democratic Republic of the", // blocked
            "CK": "Cook Islands",
            "CR": "Costa Rica",
            "CI": "Côte d'Ivoire",
            "HR": "Croatia",
            "CU": "Cuba",
            "CW": "Curaçao",
            "CY": "Cyprus",
            "CZ": "Czech Republic",
            "DK": "Denmark",
            "DJ": "Djibouti",
            "DM": "Dominica",
            "DO": "Dominican Republic",
            "EC": "Ecuador",
            "EG": "Egypt",
            "SV": "El Salvador",
            "GQ": "Equatorial Guinea",
            "ER": "Eritrea",
            "EE": "Estonia",
            "ET": "Ethiopia",
            "FK": "Falkland Islands (Malvinas)",
            "FO": "Faroe Islands",
            "FJ": "Fiji",
            "FI": "Finland",
            "FR": "France",
            "GF": "French Guiana",
            "PF": "French Polynesia",
            "TF": "French Southern Territories",
            "GA": "Gabon",
            "GM": "Gambia",
            "GE": "Georgia",
            "DE": "Germany",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GR": "Greece",
            "GL": "Greenland",
            "GD": "Grenada",
            "GP": "Guadeloupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GG": "Guernsey",
            "GN": "Guinea",
            "GW": "Guinea-Bissau",
            "GY": "Guyana",
            // "HT": "Haiti", // blocked
            "HM": "Heard Island and McDonald Islands",
            "VA": "Holy See (Vatican City State)",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Hungary",
            "IS": "Iceland",
            "IN": "India",
            "ID": "Indonesia",
            // "IR": "Iran, Islamic Republic of", // blocked
            "IQ": "Iraq",
            "IE": "Ireland",
            "IM": "Isle of Man",
            "IL": "Israel",
            "IT": "Italy",
            "JM": "Jamaica",
            "JP": "Japan",
            "JE": "Jersey",
            "JO": "Jordan",
            "KZ": "Kazakhstan",
            // "KE": "Kenya", // blocked
            "KI": "Kiribati",
            // "KP": "Korea, Democratic People's Republic of", // blocked
            "KR": "Korea, Republic of",
            "KW": "Kuwait",
            "KG": "Kyrgyzstan",
            // "LA": "Lao People's Democratic Republic", // blocked
            "LV": "Latvia",
            "LB": "Lebanon",
            "LS": "Lesotho",
            "LR": "Liberia",
            "LY": "Libya",
            "LI": "Liechtenstein",
            "LT": "Lithuania",
            "LU": "Luxembourg",
            "MO": "Macao",
            "MK": "Macedonia, the Former Yugoslav Republic of",
            "MG": "Madagascar",
            "MW": "Malawi",
            "MY": "Malaysia",
            "MV": "Maldives",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Marshall Islands",
            "MQ": "Martinique",
            "MR": "Mauritania",
            "MU": "Mauritius",
            "YT": "Mayotte",
            "MX": "Mexico",
            "FM": "Micronesia, Federated States of",
            "MD": "Moldova, Republic of",
            "MC": "Monaco",
            "MN": "Mongolia",
            "ME": "Montenegro",
            "MS": "Montserrat",
            "MA": "Morocco",
            "MZ": "Mozambique",
            // "MM": "Myanmar", // blocked
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Netherlands",
            "NC": "New Caledonia",
            "NZ": "New Zealand",
            "NI": "Nicaragua",
            "NE": "Niger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Norfolk Island",
            "MP": "Northern Mariana Islands",
            "NO": "Norway",
            "OM": "Oman",
            "PK": "Pakistan",
            "PW": "Palau",
            // "PS": "Palestine, State of", // blocked (incl. West Bank)
            // "PA": "Panama", // blocked
            "PG": "Papua New Guinea",
            "PY": "Paraguay",
            "PE": "Peru",
            "PH": "Philippines",
            "PN": "Pitcairn",
            "PL": "Poland",
            "PT": "Portugal",
            "PR": "Puerto Rico",
            "QA": "Qatar",
            "RE": "Réunion",
            "RO": "Romania",
            // "RU": "Russian Federation", // blocked
            "RW": "Rwanda",
            "BL": "Saint Barthélemy",
            "SH": "Saint Helena, Ascension and Tristan da Cunha",
            "KN": "Saint Kitts and Nevis",
            "LC": "Saint Lucia",
            "MF": "Saint Martin (French part)",
            "PM": "Saint Pierre and Miquelon",
            "VC": "Saint Vincent and the Grenadines",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "Sao Tome and Principe",
            "SA": "Saudi Arabia",
            "SN": "Senegal",
            "RS": "Serbia",
            "SC": "Seychelles",
            "SL": "Sierra Leone",
            "SG": "Singapore",
            "SX": "Sint Maarten (Dutch part)",
            "SK": "Slovakia",
            "SI": "Slovenia",
            "SB": "Solomon Islands",
            "SO": "Somalia",
            "ZA": "South Africa",
            "GS": "South Georgia and the South Sandwich Islands",
            // "SS": "South Sudan", // blocked
            "ES": "Spain",
            "LK": "Sri Lanka",
            "SD": "Sudan",
            "SR": "Suriname",
            "SJ": "Svalbard and Jan Mayen",
            "SZ": "Swaziland",
            "SE": "Sweden",
            "CH": "Switzerland",
            // "SY": "Syrian Arab Republic", // blocked
            "TW": "Taiwan, Province of China",
            "TJ": "Tajikistan",
            "TZ": "Tanzania, United Republic of",
            "TH": "Thailand",
            "TL": "Timor-Leste",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad and Tobago",
            "TN": "Tunisia",
            "TR": "Turkey",
            "TM": "Turkmenistan",
            "TC": "Turks and Caicos Islands",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ukraine",
            "AE": "United Arab Emirates",
            "GB": "United Kingdom",
            // "US": "United States", // blocked
            "UM": "United States Minor Outlying Islands",
            "UY": "Uruguay",
            "UZ": "Uzbekistan",
            "VU": "Vanuatu",
            "VE": "Venezuela, Bolivarian Republic of",
            "VN": "Viet Nam",
            "VG": "Virgin Islands, British",
            "VI": "Virgin Islands, U.S.",
            "WF": "Wallis and Futuna",
            "EH": "Western Sahara",
            "YE": "Yemen",
            "ZM": "Zambia",
            "ZW": "Zimbabwe"
        },
        EUCountriesList: [
            "AT",
            "BE",
            "BG",
            "CY",
            "CZ",
            "DE",
            "DK",
            "EE",
            "ES",
            "FI",
            "FR",
            "GR",
            "HR",
            "HU",
            "IE",
            "IT",
            "LT",
            "LU",
            "LV",
            "MT",
            "NL",
            "PL",
            "PT",
            "RO",
            "SE",
            "SI",
            "SK"
        ]
    },
    getters: {
        getCurrenciesAllList: (state) => state.currencies_all,
        getCurrencyFromAllList: (state) => (id) => id in state.currencies_all ? state.currencies_all[id] : null,
        getCurrenciesList: (state) => state.currencies,
        getCurrenciesListByIso: (state) => state.currencies_flip,
        getCurrenciesListByIsoFull: (state) => state.currencies_flip_full,
        getCurrency: (state) => (id) => id in state.currencies ? state.currencies[id] : null,
        getCurrenciesCommissionRefill: (state) => state.commissions_refill,
        getCurrenciesCommissionWithdraw: (state) => state.commissions_withdraw,
        getCurrenciesSettings: (state) => state.currencies_settings,
        getCurrenciesSettingsByCurrency: (state) => (id) => id in state.currencies_settings_by_currency ? state.currencies_settings_by_currency[id] : [],
        getNetworkAliases: (state) => state.networkAliases,
        getAllCountriesList: state => state.AllCountriesList,
        getEUCountriesList: state => state.EUCountriesList,
    },
    mutations: {
        SET_CURRENCIES_LIST(state, data) {
            state.currencies_all = data;
            state.currencies = data;

            for (const id in state.currencies) {
                const currency = state.currencies[id];
                currency.id = id;

                state.currencies_flip_full[data[id].iso3] = currency;
            }

            if (process.env.VUE_APP_ACTIVE_CURRENCIES) {
                const filter = process.env.VUE_APP_ACTIVE_CURRENCIES.split(',');

                const currencies = JSON.parse(JSON.stringify(data))

                state.currencies = Object.fromEntries(Object.entries(currencies).filter(([, v]) => filter.includes(v.iso3) || Object.entries(v.networks).filter(([i, net]) => {
                    if (filter.includes(v.iso3 + '-' + net.name.slice(0, 1))) {
                        return true;
                    }

                    delete v.networks[i];

                    return false;
                }).length > 0));
            }

            for (const id in state.currencies) {
                const currency = state.currencies[id];
                currency.id = id;

                state.currencies_flip[data[id].iso3] = currency;
            }
        },
        SET_CURRENCIES_COMMISSION_REFILL(state, data) {
            state.commissions_refill = data;
        },
        SET_CURRENCIES_COMMISSION_WITHDRAW(state, data) {
            state.commissions_withdraw = data;
        },
        SET_CURRENCIES_SETTINGS(state, data) {
            state.currencies_settings = data.currencies_settings;
            state.currencies_settings_by_currency = data.currencies_settings_by_currency_id;
        },
        SET_CURRENCIES_ICONS(state, data) {
            state.currencies_icons = data;
        }
    },
    actions: {
        async loadActiveCurrencies(context) {
            // Do get data
            return await axios.get('/api/default/active-currencies')
                .then((response) => {
                    const data = response.data;

                    if (data.status) {
                        // Set received data and Use deep copy to remove links between objects
                        context.commit('SET_CURRENCIES_LIST', data.data);
                    }

                    return true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadConfigs(context) {
            // Do get data
            return axios.get('/api/default/config')
                .then((response) => {
                    const data = response.data;

                    if (data.status) {
                        // Set commission deposit and withdraw
                        context.commit('SET_CURRENCIES_COMMISSION_WITHDRAW', data.data.commission);
                        context.commit('SET_CURRENCIES_COMMISSION_REFILL', data.data.commission_refill);

                        // Add currencies icons
                        context.commit('SET_CURRENCIES_ICONS', data.data.currency_icons);
                    }

                    return true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadCurrenciesSettings(context) {
            // Do get data
            return axios.get('/invoices/index/settings')
                .then((response) => {
                    const data = response.data;

                    if (data.status) {
                        // Set settings
                        context.commit('SET_CURRENCIES_SETTINGS', data.data);
                    }

                    return true;
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    modules: {}
};
